import { ContactEditFormValues } from "services/api/contacts/types";

import { CONTACT_WIZARD_SAMPLE } from "./consts";

export const isCompanyContact = (formValues: ContactEditFormValues) => formValues.contactTypeId === "C";

/** Naziv kontakta: tvrtki naziv, osobi ime i prezime; dok nije upisan, primjer. */
export const getContactName = (formValues: ContactEditFormValues) => {
  if (isCompanyContact(formValues)) {
    return formValues.companyName?.trim() || CONTACT_WIZARD_SAMPLE.companyName;
  }

  const name = [formValues.firstName, formValues.lastName].filter(Boolean).join(" ").trim();

  return name || CONTACT_WIZARD_SAMPLE.personName;
};

/** Inicijali za avatar (npr. "Ana Horvat" → "AH"). */
export const getInitials = (name: string) =>
  name
    .split(" ")
    .filter(Boolean)
    .slice(0, 2)
    .map((part) => part.charAt(0).toUpperCase())
    .join("");

/** Adrese slika kontakta koje se već mogu prikazati. */
export const getPictureUrls = (formValues: ContactEditFormValues) =>
  (formValues.pictures ?? []).flatMap((picture) => picture.files.map((file) => file.url)).filter((url): url is string => !!url);
